/**
 * Nickname / display name policy: block common profanity (whole-token + light leetspeak).
 * Keep in sync with `addata/src/validation/displayNamePolicy.ts`.
 */

export const DISPLAY_NAME_PROFANITY_MESSAGE =
  "That name contains language that is not allowed. Please choose another nickname.";

/** Single-token substitutions for light leetspeak (e.g. sh1t → shit). */
function deleetToken(token: string): string {
  return token
    .toLowerCase()
    .replace(/0/g, "o")
    .replace(/1/g, "i")
    .replace(/3/g, "e")
    .replace(/4/g, "a")
    .replace(/5/g, "s")
    .replace(/7/g, "t")
    .replace(/8/g, "b")
    .replace(/@/g, "a")
    .replace(/\$/g, "s");
}

const PROFANITY = new Set(
  [
    "fuck",
    "fucker",
    "fucking",
    "fucked",
    "shit",
    "shitty",
    "bitch",
    "bitches",
    "bastard",
    "ass",
    "asshole",
    "dick",
    "dickhead",
    "cock",
    "cocksucker",
    "pussy",
    "cunt",
    "slut",
    "whore",
    "nigger",
    "nigga",
    "fag",
    "faggot",
    "retard",
    "retarded",
    "rape",
    "rapist",
    "nazi",
    "spic",
    "chink",
    "kike",
    "coon",
    "twat",
    "wank",
    "wanker",
    "cum",
    "jizz",
    "milf",
    "porn",
    "porno",
    "piss",
    "pissoff",
    "bullshit",
    "motherfucker",
    "mofo",
    "suckmy",
    "suckme",
    "blowjob",
    "handjob",
    "anal",
    "anus",
    "ballsack",
    "scrotum",
    "testicle",
    "vagina",
    "penis",
    "clitoris",
    "orgasm",
    "masturbate",
    "masturbation",
    "ejaculate",
    "horny",
    "hardon",
    "boner",
    "douche",
    "douchebag",
    "jackass",
    "jackoff",
    "jerkoff",
    "prick",
    "turd",
    "dyke",
    "tranny",
  ].map((w) => w.toLowerCase())
);

export function displayNameContainsProfanity(input: string): boolean {
  const raw = input.trim();
  if (!raw) return false;
  const tokens = raw.toLowerCase().match(/[a-z0-9]+/g) ?? [];
  for (const token of tokens) {
    if (PROFANITY.has(token) || PROFANITY.has(deleetToken(token))) return true;
  }
  return false;
}
